import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import superClone from '@/assets/scripts/superClone.js';

let panduanList = []
let weeks = [{
	name: 'terminal.Sunday',
	value: 0
}, {
	name: 'terminal.Monday',
	value: 0
}, {
	name: 'terminal.Tuesday',
	value: 0
}, {
	name: 'terminal.Wednesday',
	value: 0
}, {
	name: 'terminal.Thursday',
	value: 0
}, {
	name: 'terminal.Friday',
	value: 0
}, {
	name: 'terminal.Saturday',
	value: 0
}]
const newDate = new Date();
// const year = newDate.getFullYear();
// const month = newDate.getMonth();
// start_time = year + '/' + (month < 10 ? '0' + month : month) + '/' + (date <
// 									10 ? '0' + date : date);
// const dateInfo = {
//   year: newDate.getFullYear(),
//   month: newDate.getMonth(),
//   day: newDate.getDate()
// };
// const DateDefault = new Date(dateInfo.year, dateInfo.month, dateInfo.day);
//const DateDefault = dateInfo.year + dateInfo.month + dateInfo.day
//const endTimeDefault = new Date(dateInfo.year, dateInfo.month, dateInfo.day);

const pstore = new Vuex.Store({
	state: {
		finaldata: [],
		firststep: [
			"00:00:00",
			"23:59:59",
			false,
			newDate,
			newDate,
			false,
			weeks,
			1,
			panduanList
		],
		saveTableDatas: [],
		isNewSizeRemark: false,
		newSizeRemark: '',
		addDeviceData: {},
		editDeviceData: {},
		terminalReset: {},
		isSave: false,
		publishData: [],
		currentindex: 0,
		templateData: [],
		templateIds: ""
	},
	mutations: {
		savaReset: (state, data) => {
			state.terminalReset = data;
		},
		saveNewSizeRemark: (state, [is, size]) => {
			state.isNewSizeRemark = is;
			state.newSizeRemark = size;
		},
		saveAddTerminalData: (state, data) => {
			//console.log("vuex....")
			state.addDeviceData = data;
			//console.log(state.addDeviceData)
		},
		saveEditTerminalData: (state, data) => {
			state.editDeviceData = data;
		},
		isSaveTerminal: (state, data) => {
			state.isSave = data;
		},
		saveTableData: (state, data) => {
			state.saveTableDatas = data;
			//console.log("vuex----",state.saveTableDatas)
		},
		deleteTableData: (state, data) => {
			state.saveTableDatas.splice(state.saveTableDatas.indexOf(data), 1);
		},

		increment: (state, data) => {
			for (var i = 0; i < data.length; i++) {
				state.finaldata.push({
					id: data[i].id,
					pimg: data[i].pimg,
					name: data[i].name,
					playTime: data[i].play_time,
					my_countvalue: 1,
					my_timevalue: '01:00:00',
					count: 1,
					time: '1',
					radio: 'count'
				})
			}
		},
		initTemplateLoop: (state, data) => {
			state.finaldata = data;
		},
		initTemplate: (state, data) => {
			state.finaldata = [];
			data.playList.forEach(ele => {
				let step = [];
				let isDefault = 0;
				data.scheduleList.forEach(val => {
					if (ele.id == val.play_id) {
						let week2 = val.validWeek.toString(2);
						while (week2.length < 7) {
							week2 = "0" + week2;
						}
						let weekArr = week2.split("").reverse();
						let showWeek = JSON.parse(JSON.stringify(weeks));
						weekArr.forEach((w, index) => {
							if (w == "1") {
								showWeek[index].value = 1;
							}
						})

						step.push({
							startTime: val.startTime,
							endTime: val.endTime,
							isDateLimit: val.isDateLimit == 1 ? true : false,
							dateStart: new Date(val.dateStart),
							dateEnd: new Date(val.dateEnd),
							isWeekLimit: val.isWeekLimit == 1 ? true : false,
							validWeek: showWeek,
							playCount: val.playCount,
							allNumber: val.allNumber,
							panduan: panduanList
						});
						isDefault = val.isDefault;
					}
				})
				state.finaldata.push({
					id: ele.id,
					pimg: ele.pimg,
					name: ele.name,
					isDefault,
					step: step,
					playTime: ele.play_time
				})
			});
		},
		//保存定时播放数据
		setTimePlanData: (state, data) => {
			const firststep = {
				startTime: "00:00:00",
				endTime: "23:59:59",
				isDateLimit: false,
				dateStart: newDate,
				dateEnd: newDate,
				isWeekLimit: false,
				validWeek: weeks,
				playCount: 1,
				allNumber: 0,
				panduan: panduanList
			}
			if (data[0].isDefault) {
				if (state.finaldata.length && state.finaldata[0].isDefault) {
					state.finaldata.shift();
				}
				state.finaldata.unshift({
					id: data[0].id,
					pimg: data[0].pimg,
					name: data[0].name,
					playTime: data[0].play_time,
					isDefault: data[0].isDefault,
					step: [firststep],
				})
				return;
			}
			for (let i = 0; i < data.length; i++) {
				state.finaldata.push({
					id: data[i].id,
					pimg: data[i].pimg,
					name: data[i].name,
					playTime: data[i].play_time,
					isDefault: data[i].isDefault,
					step: [firststep],

				})
			}
			console.log(state.finaldata)
		},
		//紧急插播
		setUrgencyPlan: (state, data) => {
			for (var i = 0; i < data.length; i++) {
				state.finaldata.push({
					id: data[i].id,
					pimg: data[i].pimg,
					name: data[i].name,
					playTime: data[i].play_time,
					my_countvalue: 1,
					count: 1
				})
			}
		},
		//添加计划步骤
		addPlanStep: (state) => {
			const firststep = {
				startTime: "00:00:00",
				endTime: "23:59:59",
				isDateLimit: false,
				dateStart: newDate,
				dateEnd: newDate,
				isWeekLimit: false,
				validWeek: weeks,
				playCount: 1,
				allCount: 1,
				allNumber: 0,
				panduan: panduanList
			}
			state.finaldata[state.currentindex].step.push(firststep)
			//console.log("添加计划步骤.....",state.finaldata)
		},
		confirmCurrentindex: (state, data) => {
			state.currentindex = data
		},
		//保存定时播放的时间
		saveTimePlanTime: (state, [index, plantime]) => {
			//state.finaldata[state.currentindex].step[index].startTime = plantime[0]
			//state.finaldata[state.currentindex].step[index].endTime = plantime[1]

			// state.finaldata[state.currentindex].step = JSON.parse((JSON.stringify(state.finaldata[state
			// 	.currentindex].step)))
			state.finaldata[state.currentindex].step = superClone(state.finaldata[state.currentindex].step);
			state.finaldata[state.currentindex].step[index].startTime = plantime[0]

			// state.finaldata[state.currentindex].step = JSON.parse(JSON.stringify(state.finaldata[state
			// 	.currentindex].step))
			state.finaldata[state.currentindex].step[index].endTime = plantime[1]
		},
		changeStartTime: (state, [index, time]) => {
			// state.finaldata[state.currentindex].step = JSON.parse((JSON.stringify(state.finaldata[state
			// 	.currentindex].step)))
			state.finaldata[state.currentindex].step = superClone(state.finaldata[state.currentindex].step);
			state.finaldata[state.currentindex].step[index].startTime = time;
		},
		changeEndTime: (state, [index, time]) => {
			// state.finaldata[state.currentindex].step = JSON.parse((JSON.stringify(state.finaldata[state
			// 	.currentindex].step)))
			state.finaldata[state.currentindex].step = superClone(state.finaldata[state.currentindex].step);
			state.finaldata[state.currentindex].step[index].endTime = time;
		},
		//保存定时播放日期
		// saveTimePlanDate: (state, [index, plandate]) => {
		// 	state.finaldata[state.currentindex].step = JSON.parse((JSON.stringify(state.finaldata[state
		// 		.currentindex].step)))
		// 	state.finaldata[state.currentindex].step[index].dateStart = plandate[0]
		// 	state.finaldata[state.currentindex].step[index].dateEnd = plandate[1]
		// },
		changeStartDate: (state, [index, date]) => {
			// state.finaldata[state.currentindex].step = JSON.parse((JSON.stringify(state.finaldata[state
			// 	.currentindex].step)))
			state.finaldata[state.currentindex].step = superClone(state.finaldata[state.currentindex].step);
			state.finaldata[state.currentindex].step[index].dateStart = date;
		},
		changeEndDate: (state, [index, date]) => {
			// state.finaldata[state.currentindex].step = JSON.parse((JSON.stringify(state.finaldata[state
			// 	.currentindex].step)))
			state.finaldata[state.currentindex].step = superClone(state.finaldata[state.currentindex].step);
			state.finaldata[state.currentindex].step[index].dateEnd = date;
		},
		//保存定时播放的次数
		saveTimePlanCount: (state, [index, count]) => {
			// state.finaldata[state.currentindex].step = JSON.parse(JSON.stringify(state.finaldata[state
			// 	.currentindex].step)) // eslint-disable-line no-unused-vars
			state.finaldata[state.currentindex].step = superClone(state.finaldata[state.currentindex].step); // eslint-disable-line no-unused-vars
			state.finaldata[state.currentindex].step[index].playCount = count
			//console.log("finaldata----->", state.finaldata)

			//return state.finaldata[state.currentindex].step[index][7]
		},
		//保存定时播放时候的周数
		selectWeek: (state, [weeksindex, index]) => {
			// state.finaldata[state.currentindex].step = JSON.parse(JSON.stringify(state.finaldata[state
			// 	.currentindex].step))
			state.finaldata[state.currentindex].step = superClone(state.finaldata[state.currentindex].step);
			state.finaldata[state.currentindex].step[index].validWeek[weeksindex].value = !state
				.finaldata[state.currentindex].step[index].validWeek[weeksindex].value
		},
		//点击每日时保存数据
		change_allactive: (state, index) => {
			// state.finaldata[state.currentindex].step = JSON.parse(JSON.stringify(state.finaldata[state
			// 	.currentindex].step))
			state.finaldata[state.currentindex].step = superClone(state.finaldata[state.currentindex].step);
			if (state.finaldata[state.currentindex].step[index].panduan.length < 7) {
				for (let i = 0; i < 7; i++) {
					if (state.finaldata[state.currentindex].step[index].validWeek[i].value == 0) {
						state.finaldata[state.currentindex].step[index].validWeek[i].value = 1
						state.finaldata[state.currentindex].step[index].panduan.push(state.finaldata[state
							.currentindex].step[index].validWeek[i])
					}
				}
			} else if (state.finaldata[state.currentindex].step[index].panduan.length == 7) {
				state.finaldata[state.currentindex].step[index].panduan = []
				for (let i = 0; i < 7; i++) {
					state.finaldata[state.currentindex].step[index].validWeek[i].value = 0
				}
			}

		},
		//删除计划步骤
		deletePlanStep: (state, index) => {
			if (state.finaldata[state.currentindex].step.length === 1) {
				console.log("不能再删除")
			} else {
				state.finaldata[state.currentindex].step.splice(index, 1)
			}

		},
		//点击保存时，保存选择的次数和时间
		savecount: (state, count) => {
			for (var i = 0; i < state.finaldata.length; i++) {
				if (state.currentindex === i) {
					state.finaldata[i].count = count;
				}
			}
			console.log(state.finaldata)

		},
		save_my_countvalue: (state, count) => {
			for (var i = 0; i < state.finaldata.length; i++) {
				if (state.currentindex === i) {
					state.finaldata[i].my_countvalue = count;
				}
			}
		},
		savetime: (state, time) => {
			for (var i = 0; i < state.finaldata.length; i++) {
				if (state.currentindex === i) {
					state.finaldata[i].time = time;
					//state.finaldata[i].time = time
				}
			}
		},
		save_my_time: (state, time) => {
			for (var i = 0; i < state.finaldata.length; i++) {
				if (state.currentindex === i) {
					state.finaldata[i].my_timevalue = time;
					//state.finaldata[i].time = time
				}
			}
		},
		//删除节目
		deleteitems: (state, index) => {
			if (index == state.finaldata.length - 1) {
				console.log(11111111)
				state.finaldata.splice(index, 1)
				state.currentindex = index - 1
			} else if (index == 0) {
				state.finaldata.splice(index, 1)
				state.currentindex = 0
			} else {
				state.finaldata.splice(index, 1)
				state.currentindex = index
			}
			if (state.finaldata.length == 0) {
				state.currentindex = 0
			}
		},
		copyitems: (state) => {
			if (state.finaldata.length != 0) {
				state.finaldata.splice(state.currentindex, 0, {
					id: state.finaldata[state.currentindex].id,
					pimg: state.finaldata[state.currentindex].pimg,
					name: state.finaldata[state.currentindex].name,
					count: state.finaldata[state.currentindex].count,
					time: state.finaldata[state.currentindex].time,
					radio: state.finaldata[state.currentindex].radio,
					step: state.finaldata[state.currentindex].step
				})
				state.currentindex += 1
			}
		},
		movedown: (state) => {
			var tempOption = state.finaldata[state.currentindex];
			state.finaldata.splice(state.currentindex, 1)
			state.finaldata.splice(state.currentindex + 1, 0, tempOption)
			state.currentindex += 1
		},
		moveup: (state) => {
			var tempOption = state.finaldata[state.currentindex - 1];
			state.finaldata.splice(state.currentindex - 1, 1)
			state.finaldata.splice(state.currentindex, 0, tempOption)
			state.currentindex -= 1
		},
		clearitems: (state) => {
			state.finaldata.splice(0, state.finaldata.length)
			state.currentindex = 0
		},
		getTemplateData: (state) => {
			let playids = "";
			state.finaldata.forEach(ele => {
				playids += ele.id + ',';
			})
			playids = playids.substring(0, playids.length - 1)
			state.templateIds = playids;
			let saveDate = [];
			for (let i = 0; i < state.finaldata.length; i++) {
				for (let j = 0; j < state.finaldata[i].step.length; j++) {
					let weekscount = 0
					for (let z = 0; z < 7; z++) {
						if (state.finaldata[i].step[j].validWeek[z].value == 1) {
							weekscount += Math.pow(2, z)
						}
					}
					let start_time;
					console.log('数据类型...', typeof (state.finaldata[i].step[j].dateStart))
					if (typeof (state.finaldata[i].step[j].dateStart) != "string") {
						let year = state.finaldata[i].step[j].dateStart.getFullYear();
						let month = state.finaldata[i].step[j].dateStart.getMonth() + 1;
						let date = state.finaldata[i].step[j].dateStart.getDate();
						start_time = year + '/' + (month < 10 ? '0' + month : month) + '/' + (date <
							10 ? '0' + date : date);
					} else {
						//将-换为/
						start_time = state.finaldata[i].step[j].dateStart.replace(/-/g, '/')
					}

					let end_time
					if (typeof (state.finaldata[i].step[j].dateEnd) != 'string') {
						let year1 = state.finaldata[i].step[j].dateEnd.getFullYear();
						let month1 = state.finaldata[i].step[j].dateEnd.getMonth() + 1;
						let date1 = state.finaldata[i].step[j].dateEnd.getDate();
						end_time = year1 + '/' + (month1 < 10 ? '0' + month1 : month1) + '/' + (
							date1 < 10 ? '0' + date1 : date1);
					} else {
						end_time = state.finaldata[i].step[j].dateEnd.replace(/-/g, '/')
					}
					saveDate.push({
						action: 1,
						play_id: state.finaldata[i].id,
						name: state.finaldata[i].name,
						isDefault: state.finaldata[i].isDefault,
						startTime: state.finaldata[i].step[j].startTime,
						endTime: state.finaldata[i].step[j].endTime,
						isDateLimit: state.finaldata[i].step[j].isDateLimit,
						//dateStart:state.finaldata[i].step[j].dateStart.substring(0,10),
						// dateStart: typeof(state.finaldata[i].step[j].dateStart) ==
						// 	"string" ? state.finaldata[i].step[j].dateStart.substring(0,
						// 	10) : state.finaldata[i].step[j].dateStart.toLocaleDateString(),
						// dateStart: typeof(state.finaldata[i].step[j].dateStart) ==
						// 	"string" ?
						// 	state.finaldata[i].step[j].dateStart.substring(0, 10) :
						// 	start_time,
						dateStart: start_time.substring(0, 10),
						dateEnd: end_time.substring(0, 10),
						// dateEnd: typeof(state.finaldata[i].step[j].dateEnd) == "string" ?
						// 	state.finaldata[i].step[j].dateEnd.substring(0, 10) : end_time,
						//dateEnd:state.finaldata[i].step[j].dateEnd.substring(0,10),
						//isWeekLimit:state.finaldata[i].step[j].isWeekLimit,
						isWeekLimit: weekscount == 0 ? false : true,
						validWeek: weekscount,
						playCount: state.finaldata[i].step[j].playCount,
						allNumber: state.finaldata[i].step[j].allNumber,
					})
				}
			}
			state.publishData.publish_strategy = 0;
			state.publishData.publish_type = 1;
			state.publishData.playSchedule = [];
			state.templateData = [];
			saveDate.forEach(ele => {
				state.templateData.push(ele)
			})
			console.log("template", state.templateData);
		},
		//点击发布进行处理
		publish: (state, [device_list, isMatch, fabu_type, play_mode, group_id]) => {
			if (device_list.length <= 0) {
				console.log("没有选择设备.....")
			} else {
				// console.log("发布成功")
				// console.log("发布的数据是>>>",state.finaldata)
				// console.log("发布到的设备是",device_list)
				// console.log(isMatch,fabu_type,play_mode);
				// console.log("group_id:",group_id)
				let playids = "";
				state.publishData.group_id = group_id;
				state.finaldata.forEach(ele => {
					playids += ele.id + ',';
				})
				playids = playids.substring(0, playids.length - 1)
				console.log("playid", playids)
				state.publishData.play_ids = playids;

				let deviceids = "";
				device_list.forEach(ele => {
					deviceids += ele.id + ',';
				})
				deviceids = deviceids.substring(0, deviceids.length - 1)
				if (play_mode == 1) {
					// let saveDate = [];

					// state.finaldata.forEach(ele => {
					// 	saveDate.push({
					// 		action: 1,
					// 		id: ele.id,
					// 		name: ele.name,
					// 		count: ele.count,
					// 		time: ele.time
					// 	})
					// })
					let usePlayTimeList = '';
					let playTimeList = '';
					let playCountList = '';
					state.finaldata.forEach(ele => {
						ele.count == 0 ? ele.count = ele.my_countvalue : ele.count;

						//ele.time == 0 ? ele.time = ele.my_timevalue : ele.time;
					})
					state.finaldata.forEach(ele => {
						usePlayTimeList += (ele.radio == "count" ? 0 : 1) + ',';
						if (ele.time == 0) {
							let [h, m, s] = ele.my_timevalue.split(':');
							h = h * 3600;
							m = m * 60;
							s = h + m + parseInt(s);
							ele.time = s;
							playTimeList += (ele.radio == "time" ? ele.time * 1000 : -1) + ',';
						} else {
							playTimeList += (ele.radio == "time" ? ele.time * 3600000 : -1) + ',';
						}

						playCountList += (ele.radio == "count" ? ele.count : -1) + ',';
					})
					usePlayTimeList = usePlayTimeList.substring(0, usePlayTimeList.length - 1);
					playTimeList = playTimeList.substring(0, playTimeList.length - 1);
					playCountList = playCountList.substring(0, playCountList.length - 1);

					console.log('usePlayTimeList', usePlayTimeList);
					console.log('playTimeList', playTimeList);
					console.log('playCountList', playCountList);
					state.publishData.deviceids = deviceids;
					state.publishData.play_mode = play_mode;
					state.publishData.publish_strategy = 0;
					state.publishData.publish_type = 1;
					state.publishData.isAppend = fabu_type;
					state.publishData.adapter_screen = isMatch == true ? 1 : 0;
					state.publishData.usePlayTimeList = usePlayTimeList;
					state.publishData.playTimeList = playTimeList;
					state.publishData.playCountList = playCountList;

					console.log("数据格式.....", state.publishData)
				}
				if (play_mode == 2) {
					let saveDate = [];
					for (let i = 0; i < state.finaldata.length; i++) {
						for (let j = 0; j < state.finaldata[i].step.length; j++) {
							let weekscount = 0
							for (let z = 0; z < 7; z++) {
								if (state.finaldata[i].step[j].validWeek[z].value == 1) {
									weekscount += Math.pow(2, z)
								}
							}
							let start_time;
							console.log('数据类型...', typeof (state.finaldata[i].step[j].dateStart))
							if (typeof (state.finaldata[i].step[j].dateStart) != "string") {
								let year = state.finaldata[i].step[j].dateStart.getFullYear();
								let month = state.finaldata[i].step[j].dateStart.getMonth() + 1;
								let date = state.finaldata[i].step[j].dateStart.getDate();
								start_time = year + '/' + (month < 10 ? '0' + month : month) + '/' + (date <
									10 ? '0' + date : date);
							} else {
								//将-换为/
								start_time = state.finaldata[i].step[j].dateStart.replace(/-/g, '/')
							}

							let end_time
							if (typeof (state.finaldata[i].step[j].dateEnd) != 'string') {
								let year1 = state.finaldata[i].step[j].dateEnd.getFullYear();
								let month1 = state.finaldata[i].step[j].dateEnd.getMonth() + 1;
								let date1 = state.finaldata[i].step[j].dateEnd.getDate();
								end_time = year1 + '/' + (month1 < 10 ? '0' + month1 : month1) + '/' + (
									date1 < 10 ? '0' + date1 : date1);
							} else {
								end_time = state.finaldata[i].step[j].dateEnd.replace(/-/g, '/')
							}
							saveDate.push({
								action: 1,
								play_id: state.finaldata[i].id,
								name: state.finaldata[i].name,
								isDefault: state.finaldata[i].isDefault,
								startTime: state.finaldata[i].step[j].startTime,
								endTime: state.finaldata[i].step[j].endTime,
								isDateLimit: state.finaldata[i].step[j].isDateLimit,
								//dateStart:state.finaldata[i].step[j].dateStart.substring(0,10),
								// dateStart: typeof(state.finaldata[i].step[j].dateStart) ==
								// 	"string" ? state.finaldata[i].step[j].dateStart.substring(0,
								// 	10) : state.finaldata[i].step[j].dateStart.toLocaleDateString(),
								// dateStart: typeof(state.finaldata[i].step[j].dateStart) ==
								// 	"string" ?
								// 	state.finaldata[i].step[j].dateStart.substring(0, 10) :
								// 	start_time,
								dateStart: start_time.substring(0, 10),
								dateEnd: end_time.substring(0, 10),
								// dateEnd: typeof(state.finaldata[i].step[j].dateEnd) == "string" ?
								// 	state.finaldata[i].step[j].dateEnd.substring(0, 10) : end_time,
								//dateEnd:state.finaldata[i].step[j].dateEnd.substring(0,10),
								//isWeekLimit:state.finaldata[i].step[j].isWeekLimit,
								isWeekLimit: weekscount == 0 ? false : true,
								validWeek: weekscount,
								playCount: state.finaldata[i].step[j].playCount,
								allNumber: state.finaldata[i].step[j].allNumber
							})
						}
					}
					state.publishData.deviceids = deviceids;
					state.publishData.play_mode = play_mode;
					state.publishData.publish_strategy = 0;
					state.publishData.publish_type = 1;
					state.publishData.isAppend = fabu_type;
					state.publishData.adapter_screen = isMatch == true ? 1 : 0;
					state.publishData.playSchedule = [];
					saveDate.forEach(ele => {
						state.publishData.playSchedule.push(ele)
					})
					console.log("定时播放数据格式....", state.publishData);
				}

				if (play_mode == 3) {
					let saveDate = [];
					state.finaldata.forEach(ele => {
						saveDate.push({
							action: 1,
							id: ele.id,
							name: ele.name,
							count: ele.count
						})
					})
					let playCount = '';
					let startTime = '';
					state.finaldata.forEach(ele => {
						ele.count == 0 ? ele.count = ele.my_countvalue : ele.count;

						//ele.time == 0 ? ele.time = ele.my_timevalue : ele.time;
					})
					state.finaldata.forEach(ele => {
						playCount += ele.count + ',';
						startTime += 0 + ',';
					})
					playCount = playCount.substring(0, playCount.length - 1);
					state.publishData.deviceids = deviceids;
					state.publishData.play_mode = play_mode;
					state.publishData.publish_strategy = 0;
					state.publishData.publish_type = 1;
					state.publishData.isAppend = fabu_type;
					state.publishData.adapter_screen = isMatch == true ? 1 : 0;
					//state.publishData.playSchedule = saveDate;
					state.publishData.playCount = playCount;
					state.publishData.startTime = startTime;

					console.log("数据格式.....", state.publishData)
				}
			}
		},
		savePlanDate: (state) => {
			let saveDate = []
			for (let i = 0; i < state.finaldata.length; i++) {
				for (let j = 0; j < state.finaldata[i].step.length; j++) {
					let weekscount = 0
					for (let z = 0; z < 7; z++) {
						if (state.finaldata[i].step[j].validWeek[z].value == 1) {
							weekscount += Math.pow(2, z)
						}
					}
					saveDate.push({
						action: 1,
						id: state.finaldata[i].id,
						name: state.finaldata[i].name,
						startTime: state.finaldata[i].step[j].startTime,
						endTime: state.finaldata[i].step[j].endTime,
						isDateLimit: state.finaldata[i].step[j].isDateLimit,
						//dateStart:state.finaldata[i].step[j].dateStart.substring(0,10),
						dateStart: typeof (state.finaldata[i].step[j].dateStart) == "string" ? state
							.finaldata[i].step[j].dateStart.substring(0, 10) : state.finaldata[i]
								.step[j].dateStart.toLocaleDateString(),
						dateEnd: typeof (state.finaldata[i].step[j].dateEnd) == "string" ? state
							.finaldata[i].step[j].dateEnd.substring(0, 10) : state.finaldata[i]
								.step[j].dateEnd.toLocaleDateString(),
						//dateEnd:state.finaldata[i].step[j].dateEnd.substring(0,10),
						//isWeekLimit:state.finaldata[i].step[j].isWeekLimit,
						isWeekLimit: weekscount == 0 ? false : true,
						validWeek: weekscount,
						playCount: state.finaldata[i].step[j].playCount,
					})
				}
			}
			console.log("...保存的数据是...", saveDate)
		},

		// 关于节目的操作
		deletePlay: (state, id) => {
			console.log(id)
			//admin/fabu/del

		}
	},
	// actions:{
	// 	increment:({commit}, data)=>{//
	// 		commit('increment',data)
	// 	}
	// }
})

export default pstore
